(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('FunzioneSearch', FunzioneSearch);

    FunzioneSearch.$inject = ['$resource'];

    function FunzioneSearch($resource) {
        var resourceUrl =  'api/_search/funziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
